// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";

// const DynamicImage = () => {
//   const location = useLocation();
//   const slug = location.pathname.replace("/", ""); // örnek: 'Küçükçekmece-hali-yikama'

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const imagePath = isMobile
//     ? `/${slug}-mobile.png`
//     : `/${slug}-desktop.png`; // 📂 public klasöründe iki resim olacak

//   return (
//     <div style={{ textAlign: "center", }}>
//       <img
//         src={imagePath}
//         alt={slug}
//         style={{ maxWidth: "100%", height: "auto" }}
//         onError={(e) => (e.currentTarget.style.display = "none")}
//       />
//     </div>
//   );
// };

// export default DynamicImage;
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DynamicImage = () => {
  const location = useLocation();
  const slug = location.pathname.replace("/", "").toLowerCase();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sabit görseller
  const imagePath = isMobile
    ? "/images/banner.png"
    : "/images/slider1.png";

  return (
    <div style={{ textAlign: "center" }}>
      <img
        src={imagePath}
        alt={slug}
        style={{ maxWidth: "100%", height: "auto" }}
        onError={(e) => (e.currentTarget.style.display = "none")}
      />
    </div>
  );
};

export default DynamicImage;
